import { Badge } from "components/ui/Badge";
import { TextTooltip } from "components/ui/Tooltip";
import { FormattedMessage, useIntl } from "react-intl";
import { IFinancialsStatementType } from "types/graphqlTypes";

interface StatementTypeProps {
  statementType: IFinancialsStatementType;
}
export const StatementType = ({ statementType }: StatementTypeProps) => {
  const intl = useIntl();
  const isAnnual = statementType === IFinancialsStatementType.Annual;
  const isQuarterly = statementType === IFinancialsStatementType.Quarterly;
  const isMonthly = statementType === IFinancialsStatementType.Monthly;
  let tooltipContent = intl.formatMessage({
    defaultMessage: "Balanços anuais",
    id: "yljwlY",
  });
  if (isQuarterly) {
    tooltipContent = intl.formatMessage({
      defaultMessage: "Balanços trimestrais",
      id: "CEzvss",
    });
  }
  if (isMonthly) {
    tooltipContent = intl.formatMessage({
      defaultMessage: "Balanços mensais",
      id: "U30/el",
    });
  }
  return (
    <TextTooltip
      asChild={true}
      side="top"
      align="start"
      delayDuration={1000}
      contentClassName="font-bold"
      content={tooltipContent}
    >
      <Badge variant="blue" className="rounded-md">
        {isAnnual && <FormattedMessage defaultMessage="Anual" id="nck+Ad" />}
        {isQuarterly && <FormattedMessage defaultMessage="Trimestral" id="sYUiNL" />}
        {isMonthly && <FormattedMessage defaultMessage="Mensal" id="ie4Tde" />}
      </Badge>
    </TextTooltip>
  );
};
